import styled from 'styled-components'

import { TabPanesContentContainerStyled } from '@webapp/components/TabPanes'

export const ExpenseDetailsViewStyled = styled.div`
  display: grid;
  gap: ${(props) => props.theme.space.large};
  align-items: start;

  ${TabPanesContentContainerStyled} {
    padding-top: ${(props) => props.theme.space.large};
    padding-bottom: 0;
  }

  grid-template-columns: minmax(0, 1fr);
`
